module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('modulePanel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('user')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6,
      "xs": 24,
      "sm": 6
    }
  }, [_c('div', {
    staticClass: "icon-user text-align-center"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user"
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 18,
      "xs": 24,
      "sm": 18
    }
  }, [_c('p', {
    attrs: {
      "id": "name"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('name') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.name) + "\n              ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "username"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('login') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.username) + "\n              ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "phone"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('phone') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.phone) + "\n              ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "id": "changePassword"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showChangePasswordModal()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("changePassword")) + "\n              ")])], 1)], 1), _vm._v(" "), (_vm.changePasswordModal) ? _c('ChangePasswordDialogForm', {
    attrs: {
      "instance": _vm.instance
    },
    model: {
      value: (_vm.changePasswordModal),
      callback: function($$v) {
        _vm.changePasswordModal = $$v
      },
      expression: "changePasswordModal"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('modulePanel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('businessLine')))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row display-initial"
  }, _vm._l((_vm.loggedUser.businessLines), function(row) {
    return _c('div', {
      staticClass: "col-md-4 padding-top-10px"
    }, [_c('RenderImagem', {
      attrs: {
        "height": "height: 120px;",
        "router": {
          name: 'SystemsList',
          params: {
            businessAreaId: row.id
          }
        },
        "label": row.labelPt,
        "src": _vm.getLogo(row.id)
      }
    })], 1)
  }), 0)])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9fd1a02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/user/components/UserProfile.vue
// module id = 961
// module chunks = 2